import { render, staticRenderFns } from "./goodsClassify.vue?vue&type=template&id=0403e4cd&scoped=true&"
import script from "./goodsClassify.vue?vue&type=script&lang=js&"
export * from "./goodsClassify.vue?vue&type=script&lang=js&"
import style0 from "./goodsClassify.vue?vue&type=style&index=0&id=0403e4cd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403e4cd",
  null
  
)

export default component.exports